import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBack from "@mui/icons-material/ArrowBack";

function CardBackButton({ onClick }) {
  return (
    <Box sx={{ mt: -1, ml: -1, mb: 1 }}>
      <IconButton onClick={onClick} aria-label="Go back" size="small">
        <ArrowBack fontSize="small" />
      </IconButton>
    </Box>
  );
}

export default CardBackButton;
